/**
 * Where the web app's static files live (partners.json, partners.html, the
 * demo apps). In the browser that is simply our own origin. Inside the Chrome
 * extension the page origin is chrome-extension://<id>, which has none of
 * those files, so we go by the backend the extension is pointed at.
 */
import { isExtensionContext } from './store';

const WEB_ORIGINS = {
  prod: 'https://app.comprehendpt.com',
  dev: 'https://dev.comprehendpt.com',
  // A local backend has no static site of its own; dev carries the same files.
  local: 'https://dev.comprehendpt.com',
};

export function webAppOrigin(apiClient) {
  if (typeof window !== 'undefined' && window.location && !isExtensionContext()) return window.location.origin;
  const env = typeof apiClient?.getBackendEnv === 'function' ? apiClient.getBackendEnv() : 'prod';
  return WEB_ORIGINS[env] || WEB_ORIGINS.prod;
}

/** Absolute URL for a root-relative path such as '/partners.html#start'. */
export const webAppUrl = (apiClient, path) => `${webAppOrigin(apiClient)}${path.startsWith('/') ? '' : '/'}${path}`;
